const ITEMS = [
    "Sangramento Financeiro",
    "Oportunidade Capturável",
    "Evidências",
    "Gargalos Invisíveis",
    "Abismo da Ignorância",
    "Diagnóstico Baseado em Dados",
    "Raio-X 360º",
];

export default function Marquee() {
    return (
        <section
            aria-label="Conceitos-chave da investigação"
            className="relative overflow-hidden border-y border-gold-faint bg-[#141414] py-6"
            data-testid="marquee-concepts"
        >
            <div className="flex w-max animate-marquee items-center">
                {[0, 1].map((copy) => (
                    <div key={copy} aria-hidden={copy === 1} className="flex items-center">
                        {ITEMS.map((item) => (
                            <span key={`${copy}-${item}`} className="flex items-center">
                                <span className="whitespace-nowrap px-9 font-mono text-xs uppercase tracking-[0.3em] text-[#e6e6e6]/75">
                                    {item}
                                </span>
                                <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#141414] to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#141414] to-transparent" />
        </section>
    );
}
